// Mutations
export const SET_CURRENT_PASSWORD = 'SET_CURRENT_PASSWORD'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_EMAIL_CONFIRMATION = 'SET_EMAIL_CONFIRMATION'
export const SET_FIRST_NAME = 'SET_FIRST_NAME'
export const SET_VISIBILITY = 'SET_VISIBILITY'
export const SET_LAST_NAME = 'SET_LAST_NAME'
export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_PASSWORD_CONFIRMATION = 'SET_PASSWORD_CONFIRMATION'
export const SET_JOB_TITLE = 'SET_JOB_TITLE'
export const SET_SALUTATION = 'SET_SALUTATION'
export const SET_INTERESTS = 'SET_INTERESTS'
export const RESET = 'RESET'

// Account Form
export const VISIBILITY_IS_PRIVATE = 'is_private'
export const VISIBILITY_IS_PUBLIC = 'is_public'



// WEBPACK FOOTER //
// ./src/store/modules/settings/types.js